export default function getResource(label, vars = []) {
    const resources = {
        selectYourSamplesText: 'Sélectionnez votre ou vos échantillon(s)',
        getText: 'Obtenir ',
        freeSamplesWithEveryOrderText: ' échantillon(s) gratuit(s) avec chaque commande'
    };

    return resources[label];
}
